<div class="csd-card">
  <div class="csd-header">
    <div class="csd-header-icon">
      <i class="fa fa-university"></i>
    </div>
    <div class="csd-header-text">
      <h5 class="csd-title">Campus Summary</h5>
      <p class="csd-subtitle">Attendance overview</p>
    </div>
    <button type="button" class="csd-close" (click)="close()" aria-label="Close">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="csd-stats" *ngIf="summary">
    <div class="csd-row csd-row-total">
      <div class="csd-row-icon"><i class="fa fa-users"></i></div>
      <span class="csd-row-label">Total Students</span>
      <span class="csd-row-value">{{ summary.totalStudents ?? 0 }}</span>
    </div>
    <div class="csd-row csd-row-present">
      <div class="csd-row-icon"><i class="fa fa-check-circle"></i></div>
      <span class="csd-row-label">Present</span>
      <span class="csd-row-value">{{ summary.totalPresent ?? 0 }}</span>
    </div>
    <div class="csd-row csd-row-absent">
      <div class="csd-row-icon"><i class="fa fa-times-circle"></i></div>
      <span class="csd-row-label">Absent</span>
      <span class="csd-row-value">{{ summary.totalAbsent ?? 0 }}</span>
    </div>
    <div class="csd-row csd-row-sick">
      <div class="csd-row-icon"><i class="fa fa-heartbeat"></i></div>
      <span class="csd-row-label">Sick</span>
      <span class="csd-row-value">{{ summary.totalSick ?? 0 }}</span>
    </div>
    <div class="csd-row csd-row-outing">
      <div class="csd-row-icon"><i class="fa fa-external-link"></i></div>
      <span class="csd-row-label">Outing</span>
      <span class="csd-row-value">{{ summary.totalOuting ?? 0 }}</span>
    </div>
    <div class="csd-row csd-row-transfer">
      <div class="csd-row-icon"><i class="fa fa-exchange"></i></div>
      <span class="csd-row-label">Transfer In</span>
      <span class="csd-row-value">{{ summary.transferIn ?? 0 }}</span>
    </div>
    <div class="csd-row csd-row-transfer csd-row-last">
      <div class="csd-row-icon"><i class="fa fa-exchange"></i></div>
      <span class="csd-row-label">Transfer Out</span>
      <span class="csd-row-value">{{ summary.transferOut ?? 0 }}</span>
    </div>
  </div>

  <div class="csd-actions">
    <button type="button" class="csd-btn csd-btn-close" (click)="close()">Close</button>
  </div>
</div>

<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>